import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Tooltip,
  Typography
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ArrowRight as ArrowRightIcon } from '../../../icons/arrow-right';
import { InformationCircleOutlined as InformationCircleOutlinedIcon } from '../../../icons/information-circle-outlined';
import { Chart } from '../../chart';
import { oportunidadesStatus } from '../../../utils/constants';
import { useRouter } from 'next/router';

export const OportunidadesTotales = (props) => {
  const { oportunidades = [] } = props;
  const theme = useTheme();

  const router = useRouter();

  // Construye el objeto de datos para el gráfico
  const data = {
    series: []
  };

  oportunidadesStatus.forEach((status, index) => {
    const oportunidadesPorStatus = oportunidades.filter((oportunidad) => oportunidad.status === status.value);

    if (oportunidadesPorStatus.length > 0) {
      data.series.push({
        color: status.color,
        data: oportunidadesPorStatus.length,
        label: status.label
      });
    }

  });

  const chartOptions = {
    chart: {
      background: 'transparent',
      stacked: false,
      toolbar: {
        show: false
      }
    },
    colors: data.series.map((item) => item.color),
    dataLabels: {
      enabled: false
    },
    fill: {
      opacity: 1
    },
    labels: data.series.map((item) => item.label),
    legend: {
      show: false
    },
    stroke: {
      width: 0
    },
    theme: {
      mode: theme.palette.mode
    }
  };

  const chartSeries = data.series.map((item) => item.data);

  return (
    <Card>
      <CardHeader
        title="Resumen de oportunidades"
        action={(
          <Tooltip title="De las oportunidades que has creado, aquí puedes ver el estatus de las mismas">
            <InformationCircleOutlinedIcon sx={{ color: 'action.active' }} />
          </Tooltip>
        )}
      />
      <Divider />
      <CardContent>
        <Chart
          height={200}
          options={chartOptions}
          series={chartSeries}
          type="donut"
        />
        <Grid container>
          {data.series.map((item) => (
            <Grid
              item
              key={item.label}
              sx={{
                alignItems: 'center',
                display: 'flex',
                p: 1
              }}
              xs={6}
            >
              <Box
                sx={{
                  border: 3,
                  borderColor: item.color,
                  borderRadius: '50%',
                  height: 16,
                  mr: 1,
                  width: 16
                }}
              />
              <Typography variant="subtitle2">
                {item.data} - {item.label}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </CardContent>
      <Divider />
      <CardActions>
        <Button
          endIcon={<ArrowRightIcon fontSize="small" />}
          onClick={() => router.push('/dashboard/oportunidades')}  
        >
          Ver oportunidades
        </Button>
      </CardActions>
    </Card>
  );
};

OportunidadesTotales.propTypes = {
  oportunidades: PropTypes.array.isRequired
};